import { Ref, ref } from "@vue/composition-api";
import { PIIDashboardItem } from "./models";
import { SharedState } from "@/common/state";
import { InformationType } from "@/common/models";
import * as api from "./api";

const LABEL_GROUP_ORDER = ["Contains PII", "Contains PFI", "Contains PCI"];

const DASHBOARD_SEED: PIIDashboardItem[] = ["SPI", "PII", "PFI", "PCI"].map(
  (title) => {
    return {
      title,
      items: [],
    };
  }
);

const items: Ref<PIIDashboardItem[]> = ref(DASHBOARD_SEED);

const map_result = (api_res: { y: { value: string }; count: number }[]) => {
  const PIIS = SharedState.PII.L1();
  const indexed_pii_counts = api_res
    .map(
      (f) =>
        [SharedState.getInfoType(f.y.value), f.count] as [
          InformationType,
          number
        ]
    )
    .filter(([f]) => f && f.code == 7)
    .reduce((acc, [info, count]) => {
      acc[info.id] = count;
      return acc;
    }, {} as Record<string, number>);
  // @ts-ignore
  items.value = PIIS.map((d) => {
    return {
      title: d.labelName,
      items: d.nested
        .map((l) => {
          return {
            type: "count",
            id: l.id,
            name: l.labelName,
            sensitivity: l.sensitivityLevel,
            count: indexed_pii_counts[l.id] || 0,
          };
        })
        .sort((a, b) => b.count - a.count),
    };
    // sort by order
  }).sort((a, b) => {
    return (
      LABEL_GROUP_ORDER.indexOf(a.title) - LABEL_GROUP_ORDER.indexOf(b.title)
    );
  });
};

const load_data = async () => {
  const pii_ids = SharedState.PII.L1()
    .map((d) => {
      const ids = d.nested.map((l) => l.id);
      // @ts-ignore
      if (!d.fake) {
        ids.push(d.id);
      }
      return ids;
    })
    .flat();
  const res = await api.get_all_piis(pii_ids);
  if (res.success) {
    map_result(res.value);
  }
};

export const pii_state = {
  load_data,
  items,
};
